module.exports = __webpack_public_path__ + "pw.svg?5445894875274b8709f1d6f3fd6af976";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/pw.svg
// module id = 1578
// module chunks = 0